export const Tier1PassiveCollectibles = [
    ['Brother Bobby', '8'],
    ['Lunch', '22'],
    ['Dinner', '23'],
    ['Dessert', '24'],
    ['Breakfast', '25'],
    ['Rotten Meat', '26'],
    ['Wooden Spoon', '27'],
    ['The Belt', '28'],
    ['Mom\'s Underwear', '29'],
    ['Mom\'s Heels', '30'],
    ['Mom\'s Lipstick', '31'],
    ['Magneto', '53'],
    ['Mom\'s Eye', '55'],
    ['The Ladder', '60'],
    ['Charm of the Vampire', '62'],
    ['Sister Maggy', '67'],
    ['A Quarter', '74'],
    ['Loki\'s Horns', '87'],
    ['Little Chubby', '88'],
    ['Sack of Pennies', '94'],
    ['Robo-Baby', '95'],
    ['Little Steven', '100'],
    ['The Common Cold', '103'],
    ['Forever Alone', '128'],
    ['Bucket of Lard', '129'],
    ['Bob\'s Curse', '140'],
    ['Ankh', '161'],
    ['Celtic Cross', '162'],
    ['Ghost Baby', '163'],
    ['Harlequin Baby', '167'],
    ['Rainbow Baby', '174'],
    ['Stem Cells', '176'],
    ['Guppy\'s Hair Ball', '187'],
    ['Magic 8 Ball', '194'],
    ['Mom\'s Coin Purse', '195'],
    ['Box', '198'],
    ['Mom\'s Eyeshadow', '200'],
    ['Fanny Pack', '204'],
    ['Sharp Plug', '205'],
    ['Gnawed Leaf', '210'],
    ['Spider Baby', '211'],
    ['Anemic', '214'],
    ['Piggy Bank', '227'],
    ['E Coli', '236'],
    ['Experimental Treatment', '240'],
    ['Bogo Bombs', '250'],
    ['Little Baggy', '252'],
    ['Hot Bombs', '256'],
    ['Missing No.', '258'],
    ['Robo-Baby 2.0', '267'],
    ['Headless Baby', '269'],
    ['Leech', '270'],
    ['BBF', '272'],
    ['Bob\'s Brain', '273'],
    ['Lil Haunt', '277'],
    ['Sissy Longlegs', '280'],
    ['Punching Bag', '281'],
    ['Taurus', '299'],
    ['Leo', '302'],
    ['Libra', '304'],
    ['Aquarius', '308'],
    ['Thunder Thighs', '314'],
    ['Gemini', '318'],
    ['Samson\'s Chains', '321'],
    ['Broken Watch', '337'],
    ['Safety Pin', '339'],
    ['Caffeine Pill', '340'],
    ['Match Book', '344'],
    ['A Snack', '346'],
    ['The Wiz', '358'],
    ['Friend Zone', '364'],
    ['Lost Fly', '365'],
    ['Scatter Bombs', '366'],
    ['Sticky Bombs', '367'],
    ['Epiphora', '368'],
    ['Curse of the Tower', '371'],
    ['Bursting Sack', '377'],
    ['Bumbo', '385'],
    ['Zodiac', '392'],
    ['Marked', '394'],
    ['God\'s Flesh', '398'],
    ['Spear of Destiny', '400'],
    ['Spider Mod', '403'],
    ['Farting Baby', '404'],
    ['GB Bug', '405'],
    ['Athame', '408'],
    ['Immaculate Conception', '413'],
    ['Black Powder', '420'],
    ['Papa Fly', '430'],
    ['Lil\' Loki', '435'],
    ['Milk!', '436'],
    ['Dark Prince\'s Crown', '442'],
    ['Dog Tooth', '445'],
    ['Dead Tooth', '446'],
    ['Shard of Glass', '448'],
    ['Metal Plate', '449'],
    ['Midnight Snack', '456'],
    ['Glaucoma', '460'],
    ['Finger!', '467'],
    ['Depression', '469'],
    ['King Baby', '472'],
    ['Big Chubby', '473'],
    ['Adrenaline', '493'],
    ['Duality', '498'],
    ['Greed\'s Gullet', '501'],
    ['Large Zit', '502'],
    ['Poke Go', '505'],
    ['Bloodshot Eye', '509'],
    ['Angry Fly', '511'],
    ['Fast Bombs', '517'],
    ['Leprosy', '525'],
    ['Lil Spewer', '537'],
    ['Mystery Egg', '539'],
    ['Marrow', '541'],
    ['Hallowed Ground', '543'],
    ['Jaw Bone', '548'],
    ['It Hurts', '560'],
    ['Almond Milk', '561'],
    ['Nancy Bombs', '563'],
    ['Blood Puppy', '565'],
    ['Voodoo Head', '599'],
    ['Battery Pack', '603'],
    ['Boiled Baby', '607'],
    ['Bird Cage', '610'],
    ['Booster Pack', '624'],
    ['Consolation Prize', '644'],
    ['Tinytoma', '645'],
    ['Fruity Plum', '649'],
    ['Cube Baby', '652'],
    ['Giant Cell', '658'],
    ['Tropicamide', '659'],
    ['A Pound of Flesh', '672'],
    ['Cracked Orb', '675'],
    ['Lil Portal', '681'],
    ['Sanguine Bond', '692'],
    ['Supper', '707'],
];